module.exports = __webpack_public_path__ + "static/media/Bariatric-Weight-loss-1@3x.fbd2b297.png";